import { api } from '@ezugi/utils/http/httpRequest';

import { SET_FAVORITE_URL } from '../../../endpoints';

type FavResponse = {
  result: unknown;
};

export const setFavorite = (params: {
  table_id: string;
  action: string;
  identifier: string;
}) => api.get<FavResponse>(
  `${SET_FAVORITE_URL}?${new URLSearchParams(params).toString()}`
);
